import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "ckDate",
	standalone: false
})
export class CkDatePipe implements PipeTransform {
	transform(value: number | string | Date, onlyDate = true, reverse = false, noYear = false, onlyTime = false, showSecond = false): string {
		const date = value instanceof Date ? value : new Date(value);

		if (isNaN(date.getTime())) {
			return "";
		}
		let d = [this.pad(date.getDate()), this.pad(date.getMonth() + 1)];
		if (!noYear) {
			d.push(date.getFullYear().toString());
		}
		if (reverse) {
			d = d.reverse();
		}

		if (onlyTime) {
			const ret = [this.pad(date.getHours()), this.pad(date.getMinutes())];
			if (showSecond) {
				ret.push(this.pad(date.getSeconds()));
			}
			return ret.join(':');
		}

		if (showSecond) {
			return d.join('/') +
				(onlyDate ? '' : (' ' + [this.pad(date.getHours()), this.pad(date.getMinutes()), this.pad(date.getSeconds())].join(':')));
		}

		return d.join('/') +
			(onlyDate ? '' : (' ' + [this.pad(date.getHours()), this.pad(date.getMinutes())].join(':')));
	}

	private pad = (num: number) => String(num).padStart(2, "0");
}